import styled from 'styled-components';
import { Card, Flex } from 'UI';

const DefaultCard = styled(Card)`
  width: 340px;
  min-height: 300px;
  overflow: hidden;
  height: 100%;
`;

export const SFlex = styled(Flex)`
  height: 100%;
`;

export const CardStyle1 = styled(DefaultCard)`
  background: #f7f6fa;

  .ant5-card-body {
    padding: 0px 16px 16px 16px;
  }

  .ant5-card-cover {
    padding: 16px;
  }

  img {
    border-radius: 8px !important;
    height: 160px;
    object-fit: cover;
  }
`;

export const CardStyle2 = styled(DefaultCard)`
  background: black;

  span.ecosystem-card-title {
    color: ${({ theme }) => theme.color.white};
    margin-top: -25px;
  }

  .ant5-card-body {
    background: ${({ theme }) => theme.color.brand_black};
    padding: 0px 16px 16px 16px;
    box-shadow: 0 0 15px 15px black;
    position: relative;
    z-index: 2;
  }

  img {
    max-height: 250px;
    object-fit: cover;
  }
`;

export const CardStyle3 = styled(DefaultCard)`
  img {
    border-radius: 0 !important;
    height: 160px;
    object-fit: cover;
  }

  span.ecosystem-card-title {
    color: ${({ theme }) => theme.color.brand_black};
    margin-top: -25px;
  }

  .ant5-card-body {
    padding: 16px 16px 16px 16px;
    text-align: center;
  }

  .ant5-card-head-title {
    text-align: center;
  }
`;

export const CardStyle4 = styled(DefaultCard)`
  background: #f7f6fa;

  img {
    border-radius: 0 !important;
    height: 150px;
    object-fit: cover;
    background: ${({ theme }) => theme.color.white};
  }

  .ant5-card-body {
    height: calc(100% - 150px);
    padding: 16px;
  }

  span.ecosystem-card-title {
    color: black;
  }

  .ecosystem-card-button {
    span {
      color: ${({ theme }) => theme.color.white} !important;
    }

    text-align: center;
    background: ${({ theme }) => theme.color.brand_black};
    border-radius: 6px;
  }
`;

export const CardStyle5 = styled(DefaultCard)`
  background: #f7f6fa;
  text-align: center;

  .ant5-card-body {
    height: 100%;
    padding: 16px;
  }

  span.ecosystem-card-title {
    color: ${({ theme }) => theme.color.brand_black};
  }

  .ecosystem-card-button {
    span {
      color: ${({ theme }) => theme.color.white} !important;
    }

    background: ${({ theme }) => theme.color.brand_black};
    border-radius: 6px;
  }
`;
